import { render } from "./ShowPrivateKey.vue?vue&type=template&id=6c2c1834"
import script from "./ShowPrivateKey.vue?vue&type=script&lang=js"
export * from "./ShowPrivateKey.vue?vue&type=script&lang=js"
script.render = render

export default script